var _rect, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNovenovefoodIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 92,
    viewBox: "0 0 179 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 159,
    height: 72,
    rx: 12,
    fill: "#FFD500"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 89.5,
    y: 42,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 30,
    fontWeight: "bold",
    fill: "#000000",
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "99")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 89.5,
    y: 68,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 16,
    fontWeight: "bold",
    fill: "#000000",
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "food")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovenovefoodIcon);
export default __webpack_public_path__ + "static/media/novenovefoodIcon.20dcbd5892f78077f2a0e95f15d5ba97.svg";
export { ForwardRef as ReactComponent };